import Taro, { ENV_TYPE } from "@tarojs/taro";
export default class Element {
}
Element.create = (component) => {
    if (!component) {
        throw new Error("Query create error: component is undefined or null!");
    }
    const env = Taro.getEnv();
    switch (env) {
        case ENV_TYPE.WEAPP:
            const WechatAppQuery = require("./WechatAppElement").default;
            return new WechatAppQuery(component);
        default:
        case ENV_TYPE.WEB:
            const WebQuery = require("./WebElement").default;
            return new WebQuery(component);
    }
};
